import { type Id, toast } from 'react-toastify';
import { Result } from 'ts-results-es';

export async function toastResult<D, E>(
  promise: Promise<Result<D, E>>,
  labels: {
    loading?: string;
    success?: string | ((data: D) => string | Promise<string>);
    error?: string | ((error: E) => string | Promise<string>);
    exception?: string | ((error: unknown) => string | Promise<string>);
  },
): Promise<Result<D, E>> {
  let loadingId: Id | undefined = undefined;

  try {
    // Show the loading toast
    if (labels.loading) {
      loadingId = toast.loading(labels.loading);
    }

    const result = await promise;

    if (result.isOk()) {
      // OK, show the success toast
      if (typeof labels.success === 'function') {
        toast.success(await labels.success(result.value));
      } else if (typeof labels.success === 'string') {
        toast.success(await labels.success);
      }
    } else if (result.isErr()) {
      // NOK, show the error toast
      if (typeof labels.error === 'function') {
        toast.error(await labels.error(result.error));
      } else if (typeof labels.error === 'string') {
        toast.error(await labels.error);
      }
    }

    return result;
  } catch (e) {
    // Somethign unexpected happen, show error toast
    if (typeof labels.exception === 'function') {
      toast.error(await labels.exception(e));
    } else if (typeof labels.exception === 'string') {
      toast.error(labels.exception);
    }

    throw e;
  } finally {
    if (loadingId) {
      toast.dismiss(loadingId);
    }
  }
}
